// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-dialog__footer {\n    text-align: center;\n}\n.el-dialog__header p,\n.el-dialog__body p {\n    font-size: 18px;\n}\n", ""]);
// Exports
module.exports = exports;
